var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremiumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 25.1719L0 2.25521L11.4583 12.6719L18.75 0.171875L26.0417 12.6719L37.5 2.25521L33.3333 25.1719H4.16667ZM33.3333 31.4219C33.3333 32.6719 32.5 33.5052 31.25 33.5052H6.25C5 33.5052 4.16667 32.6719 4.16667 31.4219V29.3385H33.3333V31.4219Z",
    fill: "#4EB9FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumIcon);
export default __webpack_public_path__ + "static/media/premiumIcon.54fc6f010a78669c99148e4e3aab2651.svg";
export { ForwardRef as ReactComponent };